const home = {
    "home.title": "Welcome to start point",
    "home.subtitle": "You can find all the info you need in {gettingStarted} section!"
};

export default home;